// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__24-FZ","select":"Header_select__TJA-Z","clinic":"Header_clinic__2LVAp"};